import { render } from "./Print3DCatalogoPage.vue?vue&type=template&id=3cef62ea&scoped=true"
import script from "./Print3DCatalogoPage.vue?vue&type=script&lang=js"
export * from "./Print3DCatalogoPage.vue?vue&type=script&lang=js"

import "./Print3DCatalogoPage.vue?vue&type=style&index=0&id=3cef62ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cef62ea"]])

export default __exports__